module.exports = __webpack_public_path__ + "static/media/hoist.dd8c5138.jpg";